import {fetchMembershipStripeLink} from '../endpoints/api';
import {getAnalyticsIds} from './analytics';

export type MembershipStripeLinkParams = {
  membershipId: number;
  annual?: boolean;
  sLink?: string;
  cLink?: string;
  promoCode?: string;
};

/**
 * Convenience wrapper that automatically resolves analytics IDs before
 * creating the Stripe link. Prefer this over fetchMembershipStripeLink
 * so every checkout path carries attribution data.
 */
export async function fetchMembershipStripeLinkWithAnalytics(params: MembershipStripeLinkParams) {
  const analytics = await getAnalyticsIds();
  return fetchMembershipStripeLink({...params, analytics});
}
